import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// action login & logout vuex store

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        navBarActive: '',
        showAccepts: [],
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, token) {
            state.status = 'success'
            state.token = token
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
        },
    },
    actions: {
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: `${process.env.API_PBM}/auth/login`, data: user, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.access_token
                        localStorage.setItem('token', token)
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
                        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                        axios.defaults.headers.common['Content-Type'] = 'application/json'

                        commit('auth_success', token)

                        axios
                            .post(`${process.env.API_PBM}/auth/me`)
                            .then((responseMe) => {
                                localStorage.userLogged = JSON.stringify(responseMe.data.data);
                                resolve(resp)
                            }).catch(err => {
                                reject(err)
                            });

                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit('logout')
                axios({ url: `${process.env.API_PBM}/auth/logout`, method: 'POST' })
                localStorage.removeItem('token')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        checkJWT({ commit }, jwt) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios.post(`${process.env.API_PBM}/auth/me`, {}, {
                        headers: {
                            'Authorization': 'Bearer ' + jwt,
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(resp => {
                        localStorage.setItem('token', jwt)
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
                        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                        axios.defaults.headers.common['Content-Type'] = 'application/json'

                        commit('auth_success', jwt)
                        localStorage.userLogged = JSON.stringify(resp.data.data);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },

    },



    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js